const useSegment = () => {
  if (process.env.SEGMENT_WRITE_KEY) {
    return global.analytics;
  } else {
    return null;
  }
};

export default useSegment;
